<div class="wizard connect-wizard">
  <ol class="steps">
    <li [class.active]="isConfigureNavActive()" [class.done]="isConfigureNavDone()">
      {{ 'aiMarketing.connect.navConfigure' | t }}
    </li>
    <li [class.active]="isAccountsNavActive()">{{ 'aiMarketing.connect.navAccounts' | t }}</li>
  </ol>

  @if (busy()) {
    <p class="muted">{{ 'common.loading' | t }}</p>
  }

  @if (step() === 1) {
    <p>{{ 'aiMarketing.connect.metaFlowDesc' | t }}</p>
    <div class="connect-intent-options">
      <p class="connect-permissions-title">{{ 'aiMarketing.connect.intentTitle' | t }}</p>
      <label class="connect-intent-option">
        <input type="checkbox" checked disabled />
        <span>{{ 'aiMarketing.connect.intentFacebookPage' | t }}</span>
      </label>
      <label class="connect-intent-option">
        <input
          type="checkbox"
          [checked]="wantInstagram()"
          (change)="toggleWantInstagram($any($event.target).checked)"
        />
        <span>{{ 'aiMarketing.connect.intentInstagram' | t }}</span>
      </label>
    </div>
    <div class="connect-permissions">
      <p class="connect-permissions-title">{{ 'aiMarketing.connect.permissionsTitle' | t }}</p>
      <ul>
        @for (scopeKey of permissionKeys(); track scopeKey) {
          <li>{{ scopeKey | t }}</li>
        }
      </ul>
    </div>
    <div class="connect-wizard-actions">
      @if (showBackButton()) {
        <button type="button" class="ct-btn ct-btn-ghost" [disabled]="busy()" (click)="goBack()">
          {{ 'common.back' | t }}
        </button>
      }
      <button type="button" class="ct-btn ct-btn-primary" [disabled]="busy()" (click)="startOAuth()">
        @if (busy()) {
          {{ 'common.loading' | t }}
        } @else {
          {{ 'aiMarketing.connection.connectMeta' | t }}
        }
      </button>
    </div>
  }

  @if (step() === 2) {
    <p>{{ 'aiMarketing.connect.noPages' | t }}</p>
    <a
      class="ct-btn ct-btn-primary"
      href="https://www.facebook.com/pages/creation/"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ 'aiMarketing.connect.createPage' | t }}
    </a>
    <div class="connect-wizard-actions">
      <button type="button" class="ct-btn ct-btn-ghost" [disabled]="busy()" (click)="goBack()">
        {{ 'common.back' | t }}
      </button>
      <button type="button" class="ct-btn" [disabled]="busy()" (click)="refreshAssets()">
        {{ 'aiMarketing.connect.refresh' | t }}
      </button>
    </div>
  }

  @if (step() === 3) {
    <label class="field">
      <span>{{ 'aiMarketing.connect.page' | t }}</span>
      <select class="ct-select" [ngModel]="selectedPageId()" (ngModelChange)="selectedPageId.set($event); onPageChange()">
        <option value="">{{ 'common.noneRoot' | t }}</option>
        @for (page of pages(); track page.id) {
          <option [value]="page.id">{{ page.name }}</option>
        }
      </select>
    </label>

    @if (selectedPageId() && showInstagramPicker()) {
      @if (hasInstagramOptions()) {
        <label class="field">
          <span>{{ 'aiMarketing.connect.instagram' | t }}</span>
          <select class="ct-select" [ngModel]="selectedIgId()" (ngModelChange)="selectedIgId.set($event)">
            <option value="">{{ 'aiMarketing.connect.instagramOptional' | t }}</option>
            @if (instagramOnPage().length > 0) {
              <optgroup [label]="'aiMarketing.connect.instagramOnThisPage' | t">
                @for (ig of instagramOnPage(); track ig.id) {
                  <option [value]="ig.id">{{ '@' + ig.username }}</option>
                }
              </optgroup>
            }
            @if (instagramOtherOnMeta().length > 0) {
              <optgroup [label]="'aiMarketing.connect.instagramOtherOnMeta' | t">
                @for (ig of instagramOtherOnMeta(); track ig.id) {
                  <option [value]="ig.id">{{ '@' + ig.username }}</option>
                }
              </optgroup>
            }
          </select>
        </label>
      } @else {
        <p class="muted small">{{ 'aiMarketing.connect.instagramNoneForPage' | t }}</p>
      }
    }

    <div class="connect-wizard-actions">
      <button type="button" class="ct-btn ct-btn-ghost" [disabled]="busy()" (click)="goBack()">
        {{ 'common.back' | t }}
      </button>
      <button type="button" class="ct-btn ct-btn-primary" [disabled]="busy()" (click)="saveSelection()">
        {{ 'common.save' | t }}
      </button>
    </div>
  }
</div>
